export default {
  props: {
    address: {
      type: Object,
      require: true
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/settings/addresses/index/components/resources/index.js